<template>
  <v-chip class="ma-2" color="light-blue" outlined style="padding: auto;">
    <v-icon v-if="icon && icon.name" start :size="icon.size">{{ icon.name }}</v-icon>
    <span style="padding: 10px;">{{ content }}</span>
  </v-chip>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    icon: {
      type: Object,
      default: () => ({
        name: 'mdi-credit-card',
        size: 'medium',
      }),
    },
  },
};
</script>

